import { render } from "./LocationStatusesView.vue?vue&type=template&id=94c754a8&scoped=true"
import script from "./LocationStatusesView.vue?vue&type=script&lang=js"
export * from "./LocationStatusesView.vue?vue&type=script&lang=js"

import "./LocationStatusesView.vue?vue&type=style&index=0&id=94c754a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c754a8"]])

export default __exports__